export const userLevels = [
  {
    id: 0,
    code: 'super-admin',
    name: 'Super Admin',
  },
  {
    id: 1,
    code: 'organization',
    name: 'Organization',
  },
  {
    id: 2,
    code: 'facility',
    name: 'Community',
  },
  {
    id: 3,
    code: 'organization-facility',
    name: 'Organization & Community',
  },
]
